module.exports = __webpack_public_path__ + "static/media/escudo.33e217b3.svg";